const gc_cache: any = new Object()

//if the cache key doesn't exist then return undefined
export function memCacheGet(key: string) {
    return gc_cache[key]
}
    
export function memCacheSet(key: string, value: object) {
    gc_cache[key] = value
}